export class Suggestion {
    public name: string;
    public mobile_number: string;
    public suggestion: string;
    public extra_info: string = "";
}